import { render, staticRenderFns } from "./EzeReports.vue?vue&type=template&id=c45f3a50"
import script from "./EzeReports.vue?vue&type=script&lang=js"
export * from "./EzeReports.vue?vue&type=script&lang=js"
import style0 from "./EzeReports.vue?vue&type=style&index=0&id=c45f3a50&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports